(function () {
  'use strict';

  function parseRating(value) {
    var n = parseFloat(value);
    return !isNaN(n) && n >= 1 && n <= 5 ? n : null;
  }

  function parseCount(value) {
    if (value == null) return null;
    var n = parseInt(String(value).replace(/[,\s]/g, ''), 10);
    return !isNaN(n) && n > 0 ? n : null;
  }

  function buildAggregateRating(rating, count) {
    return {
      '@type': 'AggregateRating',
      ratingValue: rating,
      reviewCount: count,
      bestRating: 5,
      worstRating: 1
    };
  }

  function applyAggregateRating(schema, rating, count) {
    var type = schema['@type'];
    var updated = false;
    if (type === 'Product') return false;
    if (type === 'Organization' || type === 'LocalBusiness') {
      schema.aggregateRating = buildAggregateRating(rating, count);
      return true;
    }
    if (schema.publisher && schema.publisher['@type'] === 'Organization') {
      schema.publisher.aggregateRating = buildAggregateRating(rating, count);
      return true;
    }
    return updated;
  }

  function updateShopSchemas(rating, count) {
    if (!rating || !count) return;
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (scriptEl) {
      try {
        var schema = JSON.parse(scriptEl.textContent);
        if (applyAggregateRating(schema, rating, count)) {
          scriptEl.textContent = JSON.stringify(schema);
        }
      } catch (e) {}
    });
  }

  function extractFromDom() {
    var rating = null;
    var count = null;

    var shopBadge = document.querySelector(
      '.jdgm-shop-badge, [class*="jdgm-shop"], [data-jdgm-shop-badge], .jdgm-all-reviews__summary'
    );
    if (shopBadge) {
      rating = parseRating(shopBadge.getAttribute('data-score') || shopBadge.getAttribute('data-average-rating'));
      count = parseCount(
        shopBadge.getAttribute('data-number-of-reviews') ||
        shopBadge.getAttribute('data-review-count')
      );
      if (!rating || !count) {
        var text = shopBadge.textContent || '';
        if (!rating) {
          var ratingMatch = text.match(/(\d+\.?\d*)\s*(?:out of|\/|stars?)/i) ||
            text.match(/(\d+\.?\d*)\s*[★☆]/);
          if (ratingMatch) rating = parseRating(ratingMatch[1]);
        }
        if (!count) {
          var countMatch = text.match(/(\d[\d,\s]*)\s*reviews?/i);
          if (countMatch) count = parseCount(countMatch[1]);
        }
      }
    }

    if (!rating || !count) {
      var summary = document.querySelector(
        '.jdgm-rev-widg__summary-text, .jdgm-rev-widg__reviews-count, .jdgm-all-reviews__rating, .judgeme-badge'
      );
      if (summary) {
        var summaryText = summary.textContent || '';
        if (!rating) {
          var rMatch = summaryText.match(/(\d+\.?\d*)/);
          if (rMatch) rating = parseRating(rMatch[1]);
        }
        if (!count) {
          var cMatch = summaryText.match(/(\d[\d,\s]*)\s*reviews?/i);
          if (cMatch) count = parseCount(cMatch[1]);
        }
      }
    }

    return { rating: rating, count: count };
  }

  function extractFromJudgeMeApi() {
    var rating = null;
    var count = null;
    var jm = window.judgeme || window.jdgm;

    if (!jm) return { rating: rating, count: count };

    if (jm.shopReviewCount != null || jm.shopRating != null) {
      count = parseCount(jm.shopReviewCount || jm.allReviewsCount);
      rating = parseRating(jm.shopRating || jm.allReviewsRating);
    }

    if ((!rating || !count) && jm.allReviews) {
      count = parseCount(jm.allReviews.total_reviews || jm.allReviews.reviews_count);
      rating = parseRating(jm.allReviews.average_rating || jm.allReviews.rating);
    }

    if ((!rating || !count) && jm.settings) {
      count = parseCount(jm.settings.shop_review_count || jm.settings.all_reviews_count);
      rating = parseRating(jm.settings.shop_review_rating || jm.settings.all_reviews_rating);
    }

    return { rating: rating, count: count };
  }

  function tryUpdate() {
    var api = extractFromJudgeMeApi();
    var dom = extractFromDom();
    var rating = api.rating || dom.rating;
    var count = api.count || dom.count;
    if (rating && count) {
      updateShopSchemas(rating, count);
      return true;
    }
    return false;
  }

  function run() {
    if (tryUpdate()) return;
    var attempts = 0;
    var interval = setInterval(function () {
      attempts += 1;
      if (tryUpdate() || attempts >= 20) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  ['judgeme:loaded', 'judgeme:reviews-loaded', 'judgeme:ready'].forEach(function (eventName) {
    window.addEventListener(eventName, tryUpdate);
  });
})();
